<template>
<div class="cp-root" :style="themePageStyle">

  <nav class="cp-topbar"><div class="container d-flex align-items-center justify-content-between py-2">
    <div class="d-flex align-items-center" style="gap:12px;">
      <a href="javascript:void(0)" @click="$router.push('/sell/products')"><i class="mdi mdi-arrow-left" style="color:var(--fm-m,#A09888);font-size:22px;"></i></a>
      <a href="javascript:void(0)" @click="$router.push('/dashboard')"><img src="assets/images/flockr_logo.png" alt="Flockr" style="height:30px;" /></a>
      <span class="fw-semibold" style="color:var(--fm-h,#F5F0E8);font-size:14px;">{{ isEdit ? 'Edit Product' : 'New Product' }}</span>
    </div>
    <button class="btn btn-sm btn-outline-warning" @click="$router.push('/sell/products')">My Products</button>
  </div></nav>

  <div class="container cp-container">
    <div v-if="loading" class="text-center py-5"><div class="spinner-border text-warning"></div></div>

    <form v-else @submit.prevent="submit">

      <!-- Basics -->
      <div class="cp-card">
        <h6 class="cp-section-title"><i class="mdi mdi-tag-outline me-1" style="color:#BFA164;"></i>Basics</h6>
        <div class="row g-3">
          <div class="col-md-8">
            <label class="cp-lbl">Product name <span style="color:#FF6B6B;">*</span></label>
            <input v-model="form.name" class="form-control cp-input" placeholder="e.g., Unga Dairy Meal 16% — 70kg bag" />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">Category <span style="color:#FF6B6B;">*</span></label>
            <select v-model="form.categoryId" class="form-select cp-input">
              <option value="">Select</option>
              <option v-for="c in categories" :key="c.id" :value="c.id">{{ c.name }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="cp-lbl">Brand</label>
            <input v-model="form.brand" class="form-control cp-input" placeholder="Unga, Sigma, Pembe..." />
          </div>
          <div class="col-md-6">
            <label class="cp-lbl">Manufacturer</label>
            <input v-model="form.manufacturer" class="form-control cp-input" />
          </div>
          <div class="col-12">
            <label class="cp-lbl">Short description</label>
            <input v-model="form.shortDescription" class="form-control cp-input" placeholder="One-line teaser shown on the product card" maxlength="500" />
          </div>
          <div class="col-12">
            <label class="cp-lbl">Full description <span style="color:#FF6B6B;">*</span></label>
            <textarea v-model="form.description" class="form-control cp-input" rows="6" placeholder="What's in the product, what it's for, why farmers should buy it..."></textarea>
          </div>
        </div>
      </div>

      <!-- Pricing & stock -->
      <div class="cp-card">
        <h6 class="cp-section-title"><i class="mdi mdi-cash me-1" style="color:#BFA164;"></i>Pricing &amp; Stock</h6>
        <div class="row g-3">
          <div class="col-md-4">
            <label class="cp-lbl">Price (KES) <span style="color:#FF6B6B;">*</span></label>
            <input type="number" v-model.number="form.price" class="form-control cp-input" />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">Compare-at price (optional)</label>
            <input type="number" v-model.number="form.compareAtPrice" class="form-control cp-input" placeholder="Original price for showing a discount" />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">Price unit</label>
            <input v-model="form.priceUnit" class="form-control cp-input" placeholder="bag, kg, piece, litre..." />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">Stock quantity <span style="color:#FF6B6B;">*</span></label>
            <input type="number" v-model.number="form.stockQuantity" class="form-control cp-input" />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">Low-stock alert at</label>
            <input type="number" v-model.number="form.lowStockThreshold" class="form-control cp-input" />
          </div>
          <div class="col-md-4">
            <label class="cp-lbl">SKU (optional)</label>
            <input v-model="form.sku" class="form-control cp-input" placeholder="Internal product code" />
          </div>
          <div class="col-md-6">
            <label class="cp-lbl">Allow backorders?</label>
            <select v-model.number="form.allowBackorder" class="form-select cp-input">
              <option :value="0">No (out of stock when 0)</option>
              <option :value="1">Yes (buyers can pre-order)</option>
            </select>
          </div>
          <div class="col-md-6">
            <label class="cp-lbl">Weight (kg, for shipping)</label>
            <input type="number" step="0.01" v-model.number="form.weightKg" class="form-control cp-input" />
          </div>
        </div>
      </div>

      <!-- Photos -->
      <div class="cp-card">
        <h6 class="cp-section-title"><i class="mdi mdi-camera me-1" style="color:#BFA164;"></i>Photos
          <span style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:400;">(up to 6 — auto-compressed)</span>
        </h6>
        <div class="cp-photo-row">
          <div v-for="(p, pi) in form.photos" :key="pi" class="cp-photo-thumb">
            <img :src="p.preview" />
            <button type="button" class="cp-photo-remove" @click="removePhoto(pi)"><i class="mdi mdi-close"></i></button>
            <span v-if="pi === 0" class="cp-photo-primary">PRIMARY</span>
          </div>
          <label v-if="form.photos.length < 6 && !compressing" class="cp-photo-add">
            <input type="file" accept="image/*" multiple @change="onPhotoPick" />
            <i class="mdi mdi-camera-plus" style="font-size:24px;"></i>
            <span style="font-size:10px;margin-top:4px;">Add photo</span>
          </label>
          <div v-if="compressing" class="cp-photo-add" style="pointer-events:none;">
            <span class="spinner-border spinner-border-sm text-warning"></span>
          </div>
        </div>
        <div style="font-size:11px;color:var(--fm-s,#6B6356);margin-top:6px;">
          The first photo is used as the primary image on the product card. Drag-rearrange isn't supported yet — re-upload to change order.
        </div>
      </div>

      <!-- Pharma / vet drug fields (optional) -->
      <div class="cp-card">
        <h6 class="cp-section-title"><i class="mdi mdi-flask-outline me-1" style="color:#BFA164;"></i>Vet Drug / Feed Details
          <span style="color:var(--fm-s,#6B6356);font-size:11px;font-weight:400;">(optional)</span>
        </h6>
        <div class="row g-3">
          <div class="col-12">
            <label class="cp-lbl">Ingredients / active components</label>
            <textarea v-model="form.ingredients" class="form-control cp-input" rows="3" placeholder="For feeds: protein content, vitamins, minerals.&#10;For drugs: active ingredient + concentration."></textarea>
          </div>
          <div class="col-12">
            <label class="cp-lbl">Dosage instructions (drugs only)</label>
            <textarea v-model="form.dosageInstructions" class="form-control cp-input" rows="3" placeholder="e.g., 1ml per 10kg body weight, IM injection, repeat after 14 days."></textarea>
          </div>
          <div class="col-md-6">
            <label class="cp-lbl">Prescription required?</label>
            <select v-model.number="form.isPrescriptionRequired" class="form-select cp-input">
              <option :value="0">No</option>
              <option :value="1">Yes — requires vet approval before delivery</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Status / publish -->
      <div class="cp-card">
        <h6 class="cp-section-title"><i class="mdi mdi-rocket-launch-outline me-1" style="color:#BFA164;"></i>Visibility</h6>
        <div class="row g-3">
          <div class="col-md-6">
            <label class="cp-lbl">Status</label>
            <select v-model="form.status" class="form-select cp-input">
              <option value="draft">Draft (hidden)</option>
              <option value="active">Active (visible to buyers)</option>
              <option value="paused">Paused (temporarily hidden)</option>
            </select>
          </div>
        </div>
      </div>

      <div v-if="error" class="text-danger mt-3" style="font-size:13px;">{{ error }}</div>

      <div class="d-flex gap-2 mt-3">
        <button type="button" class="btn btn-outline-secondary" @click="$router.push('/sell/products')" :disabled="submitting">Cancel</button>
        <button type="submit" class="btn btn-warning flex-fill" :disabled="submitting || !canSubmit">
          <span v-if="submitting" class="spinner-border spinner-border-sm me-1"></span>
          <i v-else class="mdi mdi-content-save me-1"></i>
          {{ submitting ? 'Saving...' : (isEdit ? 'Update Product' : 'Publish Product') }}
        </button>
      </div>
    </form>
  </div>
</div>
</template>

<style>
:root{--fm-h:#F5F0E8;--fm-s:#6B6356;--fm-m:#A09888;--fm-bg1:#141414;--fm-bg2:#0F0F0F;--fm-bg3:#1E1E1E;--fm-br:#1E1E1E}
html[data-theme="light"]{--fm-h:#1A1A1A;--fm-s:#777;--fm-m:#555;--fm-bg1:#FFFFFF;--fm-bg2:#F7F5F2;--fm-bg3:#F0EBE4;--fm-br:#E8E2DA}
html[data-theme="light"] body{background:#F7F5F2!important}
html[data-theme="light"] .cp-root{background:#F7F5F2!important;color:#1A1A1A!important}
html[data-theme="light"] .cp-topbar{background:rgba(255,255,255,.95)!important;border-bottom-color:#E8E2DA!important}
html[data-theme="light"] .cp-card{background:#FFFFFF!important;border-color:#E8E2DA!important}
html[data-theme="light"] .cp-input{background:#FFFFFF!important;border-color:#E8E2DA!important;color:#1A1A1A!important}
</style>

<style scoped>
.cp-root{background:var(--fm-bg2,#0A0A0A);min-height:100vh;color:var(--fm-h,#F5F0E8)}
.cp-topbar{position:sticky;top:0;z-index:100;padding:10px 0;background:var(--fm-bg1,#141414);backdrop-filter:blur(10px);border-bottom:1px solid var(--fm-br,#1E1E1E)}
.cp-container{padding-top:80px;padding-bottom:60px;max-width:820px}
.cp-card{background:var(--fm-bg1,#141414);border:1px solid var(--fm-br,#1E1E1E);border-radius:12px;padding:18px 20px;margin-bottom:14px}
.cp-section-title{color:var(--fm-h,#F5F0E8);margin-bottom:14px}
.cp-lbl{display:block;color:var(--fm-h,#F5F0E8);font-size:12px;font-weight:600;margin-bottom:6px}
.cp-input{background:var(--fm-bg2,#0F0F0F)!important;border:1px solid var(--fm-br,#1E1E1E);color:var(--fm-h,#F5F0E8)!important;font-size:13px}
.cp-input:focus{border-color:#BFA164;box-shadow:0 0 0 2px rgba(191,161,100,.15)}

.cp-photo-row{display:flex;flex-wrap:wrap;gap:8px}
.cp-photo-thumb{position:relative;width:96px;height:96px;border-radius:8px;overflow:hidden;background:var(--fm-bg2,#0F0F0F);border:1px solid var(--fm-br,#1E1E1E)}
.cp-photo-thumb img{width:100%;height:100%;object-fit:cover}
.cp-photo-remove{position:absolute;top:3px;right:3px;width:22px;height:22px;border-radius:50%;background:rgba(0,0,0,.7);border:none;color:#FF6B6B;font-size:13px;cursor:pointer;display:flex;align-items:center;justify-content:center}
.cp-photo-primary{position:absolute;bottom:3px;left:3px;background:rgba(191,161,100,.9);color:#1A1A1A;font-size:9px;padding:1px 6px;border-radius:4px;font-weight:700;letter-spacing:.3px}
.cp-photo-add{width:96px;height:96px;border-radius:8px;border:2px dashed var(--fm-br,#1E1E1E);background:var(--fm-bg2,#0F0F0F);display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;color:var(--fm-s,#6B6356)}
.cp-photo-add:hover{border-color:#BFA164;color:#BFA164}
.cp-photo-add input{display:none}
</style>

<script>
/* eslint-disable */
import { execute, executeJson, flocker } from "@/api";

function compressImage(file, maxDim, quality){
  return new Promise(function(resolve){
    var reader = new FileReader();
    reader.onload = function(e){
      var img = new Image();
      img.onload = function(){
        var w = img.width, h = img.height;
        if (w > maxDim || h > maxDim) {
          if (w > h) { h = Math.round(h * maxDim / w); w = maxDim; }
          else       { w = Math.round(w * maxDim / h); h = maxDim; }
        }
        var canvas = document.createElement('canvas');
        canvas.width = w; canvas.height = h;
        canvas.getContext('2d').drawImage(img, 0, 0, w, h);
        canvas.toBlob(function(blob){
          if (!blob) { resolve({ file: file, preview: e.target.result }); return; }
          var emit = function(b){
            var name = file.name.replace(/\.[^.]+$/, '.jpg');
            var f = new File([b], name, { type: 'image/jpeg' });
            resolve({ file: f, preview: URL.createObjectURL(f) });
          };
          if (blob.size > 2 * 1024 * 1024) {
            canvas.toBlob(function(b2){ emit(b2 || blob); }, 'image/jpeg', 0.6);
          } else { emit(blob); }
        }, 'image/jpeg', quality);
      };
      img.src = e.target.result;
    };
    reader.readAsDataURL(file);
  });
}

export default {
  name: "CreateProductPage",
  data(){return{
    darkMode:(document.documentElement.getAttribute('data-theme')||localStorage.getItem('flockr_theme')||'dark')!=='light',
    themeObserver:null, loading:false,
    categories:[],
    form: {
      name:'', categoryId:'', brand:'', manufacturer:'', shortDescription:'', description:'',
      price:null, compareAtPrice:null, priceUnit:'', stockQuantity:0, lowStockThreshold:5, sku:'',
      allowBackorder:0, weightKg:null,
      ingredients:'', dosageInstructions:'', isPrescriptionRequired:0,
      status:'active',
      photos:[]
    },
    compressing:false, submitting:false, error:''
  }},
  computed:{
    themePageStyle(){return this.darkMode?'background:#0A0A0A;min-height:100vh;color:#F5F0E8;':'background:#F7F5F2;min-height:100vh;color:#1A1A1A;'},
    isEdit(){return !!this.$route.params.id},
    canSubmit(){
      return !!(this.form.name && this.form.categoryId && this.form.description && Number(this.form.price) > 0);
    }
  },
  mounted(){
    this._applyThemeOnce();
    var self=this;
    this.themeObserver=new MutationObserver(function(){try{self._applyThemeOnce();}catch(e){}});
    this.themeObserver.observe(document.documentElement,{attributes:true,attributeFilter:['data-theme']});
    if(!sessionStorage.getItem('userId')){this.$router.push('/login?redirect=/sell/products');return}
    this.loadCategories();
    if (this.isEdit) this.loadExisting();
  },
  beforeUnmount(){if(this.themeObserver){this.themeObserver.disconnect();this.themeObserver=null}},
  methods:{
    _applyThemeOnce(){
      var current=document.documentElement.getAttribute('data-theme');
      var desired=(localStorage.getItem('flockr_theme')||current||'dark');
      if(current!==desired) document.documentElement.setAttribute('data-theme',desired);
      this.darkMode=desired!=='light';
    },
    async loadCategories(){
      try{var r=await executeJson({function:'getProductCategories'},flocker);
        if(r.data&&r.data.success){
          var d=r.data.data;
          this.categories=(d&&d.categories)||(Array.isArray(d)?d:[]);
        }
      }catch(e){}
    },
    async loadExisting(){
      this.loading=true;
      try{
        var r=await executeJson({function:'getProduct',productId:this.$route.params.id},flocker);
        if(r.data&&r.data.success&&r.data.data&&r.data.data.product){
          var p=r.data.data.product;
          if (p.seller_id !== sessionStorage.getItem('userId')) {
            this.error="That's not your product"; this.loading=false; return;
          }
          this.form={
            name:p.name||'', categoryId:p.category_id||'',
            brand:p.brand||'', manufacturer:p.manufacturer||'',
            shortDescription:p.short_description||'', description:p.description||'',
            price:p.price?Number(p.price):null, compareAtPrice:p.compare_at_price?Number(p.compare_at_price):null,
            priceUnit:p.price_unit||'', stockQuantity:Number(p.stock_quantity||0),
            lowStockThreshold:Number(p.low_stock_threshold||5), sku:p.sku||'',
            allowBackorder:Number(p.allow_backorder||0), weightKg:p.weight_kg?Number(p.weight_kg):null,
            ingredients:p.ingredients||'', dosageInstructions:p.dosage_instructions||'',
            isPrescriptionRequired:Number(p.is_prescription_required||0),
            status:p.status||'active',
            photos:[]  // existing photos shown by URL only — re-uploading replaces primary
          };
        }
      }catch(e){console.error(e)}
      this.loading=false;
    },
    async onPhotoPick(event){
      var files=Array.from(event.target.files||[]);
      var slots=6-this.form.photos.length;
      if(slots<=0){event.target.value='';return}
      var picked=files.slice(0,slots).filter(function(f){return f.type.indexOf('image/')===0});
      this.compressing=true;
      try{
        for(var i=0;i<picked.length;i++){
          var c=await compressImage(picked[i],1200,0.8);
          this.form.photos.push({file:c.file,preview:c.preview});
        }
      }catch(e){this.error='Could not process photo'}
      this.compressing=false;
      event.target.value='';
    },
    removePhoto(idx){
      var p=this.form.photos[idx];
      if(p&&p.preview&&p.preview.indexOf('blob:')===0) URL.revokeObjectURL(p.preview);
      this.form.photos.splice(idx,1);
    },
    async submit(){
      if(!this.canSubmit)return;
      this.submitting=true; this.error='';
      try{
        var fd=new FormData();
        if (this.isEdit) {
          fd.append('function','updateProduct');
          fd.append('productId',this.$route.params.id);
          fd.append('sellerId',sessionStorage.getItem('userId'));
        } else {
          fd.append('function','addProduct');
          fd.append('sellerId',sessionStorage.getItem('userId'));
        }
        // Common fields
        var f=this.form;
        fd.append('name',f.name);
        fd.append('categoryId',f.categoryId);
        fd.append('description',f.description);
        if(f.shortDescription) fd.append('shortDescription',f.shortDescription);
        fd.append('price',String(f.price));
        if(f.compareAtPrice) fd.append('compareAtPrice',String(f.compareAtPrice));
        if(f.priceUnit) fd.append('priceUnit',f.priceUnit);
        fd.append('stockQuantity',String(f.stockQuantity||0));
        fd.append('lowStockThreshold',String(f.lowStockThreshold||5));
        if(f.sku) fd.append('sku',f.sku);
        fd.append('allowBackorder',String(f.allowBackorder||0));
        if(f.weightKg) fd.append('weightKg',String(f.weightKg));
        if(f.brand) fd.append('brand',f.brand);
        if(f.manufacturer) fd.append('manufacturer',f.manufacturer);
        if(f.ingredients) fd.append('ingredients',f.ingredients);
        if(f.dosageInstructions) fd.append('dosageInstructions',f.dosageInstructions);
        fd.append('isPrescriptionRequired',String(f.isPrescriptionRequired||0));
        fd.append('status',f.status);
        // Photos
        var pi=0;
        f.photos.forEach(function(p){fd.append('photo'+pi,p.file);pi++});

        var r=await execute(fd,flocker);
        if(r.data&&r.data.success){
          this.$router.push('/sell/products');
        }else{
          this.error=(r.data&&r.data.message)||'Could not save product';
        }
      }catch(e){this.error=(e&&e.message)||'Network error'}
      this.submitting=false;
    }
  }
};
</script>
